<template>
  <div v-if="canSeeNavItem">
    <template
      v-if="
        model.children !== undefined &&
          model.children.length &&
          (!routeScope(model) || this.$cnc.scope(routeScope(model))) &&
            (!model.scope || this.$cnc.scope(model.scope))
      "
    >
      <div class="navbar-item has-dropdown is-hoverable">
        <router-link
          :to="model.route || '#'"
          :class="{ 'navbar-item': true, 'is-active': containsActive }"
          >{{ model.label }}</router-link
        >
        <div class="navbar-dropdown">
          <NavBarItem
            v-for="child in model.children"
            :key="child.id"
            :model="child"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <router-link
        v-if="
          (!routeScope(model) || this.$cnc.scope(routeScope(model))) &&
            (!model.scope || this.$cnc.scope(model.scope))
        "
        :to="model.route || '#'"
        :class="{ 'navbar-item': true, 'is-active': containsActive }"
        >{{ model.label }}</router-link
      >
    </template>
  </div>
</template>
<script>
export default {
  name: "NavBarItem",
  props: {
    model: Object
  },
  computed: {
    containsActive() {
      return containsRoute(this.model, this.$route)
    },
    canSeeNavItem() {
      if (!this.model.route) {
        return true
      }

      if (
        !this.model.route.name.match(
          /^[A-Z][A-Za-z0-9]*-(create|read|update|delete|list)$/
        )
      ) {
        return true
      }

      const [schemaName, action] = this.model.route.name.split("-", 2)
      return this.$cnc.can(action, schemaName)
    }
  },
  methods: {
    routeScope(model) {
      for (const route of this.$router.options.routes) {
        if (model.route && route.name === model.route.name) {
          return route.meta.scope
        }
      }
    }
  }
}

function containsRoute(item, route) {
  return (
    (item.route && item.route.name == route.name) ||
    (item.children || []).some(child => containsRoute(child, route))
  )
}
</script>
<style scoped>
@media only screen and (min-width: 1024px) {
  .navbar-start > div > .navbar-item,
  .navbar-start > div > .navbar-item.has-dropdown > .navbar-item {
    color: #008da2;
    background-color: #fafafa;
  }
}
.navbar-start > div > .navbar-item:hover,
.navbar-start > div > .navbar-item.is-active,
.navbar-start > div > .navbar-item.has-dropdown > .navbar-item:hover,
.navbar-start > div > .navbar-item.has-dropdown:hover > .navbar-item,
.navbar-start > div > .navbar-item.has-dropdown > .navbar-item.is-active {
  background-color: #008da2;
  color: #fafafa;
}
</style>
